// Central config. Read import.meta.env only here.
//
// Per-environment values come at runtime from /config.js (the container entrypoint
// writes it), so one image serves every environment. The build-time value is the
// fallback for local `vite dev`.
declare global {
  interface Window {
    __APP_CONFIG__?: Partial<Record<string, string>>;
  }
}

const runtime = window.__APP_CONFIG__ ?? {};

function backendOrigin(): string {
  const explicit = runtime.VITE_BACKEND_URL || (import.meta.env.VITE_BACKEND_URL as string | undefined);
  if (explicit) return explicit.replace(/\/$/, '');
  // Convention of this project: the API lives on backend.<frontend host>
  // (dentlog.docker.localhost → backend.dentlog.docker.localhost,
  //  dev.dentlog.studiopresent.ai → backend.dev.dentlog.studiopresent.ai).
  const { protocol, host } = window.location;
  return `${protocol}//backend.${host}`;
}

const origin = backendOrigin();

export const env = {
  backendOrigin: origin,
  apiBaseUrl: `${origin}/api`,
  appName: runtime.VITE_APP_NAME || (import.meta.env.VITE_APP_NAME as string | undefined) || 'Dentlog',
  environment: runtime.VITE_ENV || (import.meta.env.VITE_ENV as string | undefined) || 'local',
  isProduction: import.meta.env.PROD,
} as const;
